import { render, staticRenderFns } from "./subdivisionsMainView.vue?vue&type=template&id=96868cba&scoped=true&"
import script from "./subdivisionsMainView.vue?vue&type=script&lang=js&"
export * from "./subdivisionsMainView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96868cba",
  null
  
)

export default component.exports